import { createContext } from 'react';

const RecoverDiceEnergyContext = createContext(
  {} as {
    currentTimeToRecoverOneEnergy: number;
  },
);

export { RecoverDiceEnergyContext };
